import {HttpClient} from './httpClient' 
import {API_URL} from './RestAPI'
import apiHeaders from './apiHeaders'

//Setting the store API URI
const STORE_API = `${API_URL}/store`
const CURRENCY_API = `${API_URL}/currencies`

const getCurrencies = () => {
  return HttpClient.get(
    `${CURRENCY_API}/`,
    apiHeaders()
  )
}

// Get
const getStore = () => {
  return HttpClient.get(
    `${STORE_API}/retrieve`,
    apiHeaders()
  )
}

// Get
const getStoreAuthWithConfig = () => {
  return HttpClient.get(
    `${STORE_API}/store-auths`,
    apiHeaders()
  )
}

// Update
const updateStore = (store) => {
  return HttpClient.put(
    `${STORE_API}/update`,
    store,
    apiHeaders()
  )
}

const validateStoreUrl = (payload) => {
  return HttpClient.post(
    `${STORE_API}/store-url`,
    payload,
    apiHeaders()
  )
}

const createStripeAccount = (payload = {}) => {
  return HttpClient.post(`${STORE_API}/stripe-connect`, payload, apiHeaders());
}

const getStripeStatus = () => {
  return HttpClient.get(`${STORE_API}/stripe-status`, apiHeaders());
}

const getStripeDashboardLink = () => {
  return HttpClient.get(`${STORE_API}/stripe-dashboard-link`, apiHeaders());
}

const disconnectStripeAccount = () => {
  return HttpClient.post(`${STORE_API}/stripe-disconnect`, {}, apiHeaders());
};

//Encapsulating in a JSON object
const StoreApi = { getStore, updateStore, validateStoreUrl, getCurrencies, createStripeAccount, getStripeStatus, getStripeDashboardLink, disconnectStripeAccount, getStoreAuthWithConfig}

export {StoreApi}
